export const initialState = {
  auth: {
    userData: {},
    balance: {},
    accessToken: null,
    refreshToken: null,
    isLoggedIn: false,
    isRefreshing: false,
    isLoading: false,
    error: null,
  },

  cars: {
    cars: [],
    carInfo: {},
    additionalInfo: {},
    nodesAndPartsForDiagnostics: [],
    diagnostic: {},
    repairDetails: {},
    chosenDate: '',
    newCar: {},
    convertedMedia: [],
    mileageOrVin: {},
    voiceDiagnostic: {},

    isLoading: false,
    isRecognitionLoading: false,
    isInfoByPlateLoading: false,
    isDiagLoading: false,
    isDiagCreateLoading: false,
    isSavingCarLoading: false,
    isRepairLoading: false,
    isConvertingMedia: false,
    isMileageOrVinLoading: false,
    isVoiceDiagLoading: false,

    error: null,
  },
};
